import React from "react";
import { Edit, SimpleForm, TextField, TextInput } from "react-admin";

const DistrictEdit = (props) => {
  return (
    <Edit undoable={false} {...props}>
      <SimpleForm>
        <TextField source="id" />
        <TextField source="seasonCode" />
        <TextField source="sportCode" />
        <TextInput source="leagueCode" />
        <TextInput source="conferenceCode" />
        <TextInput source="divisionCode" />
        <TextInput source="regionCode" />
        <TextInput source="districtCode" />
        <TextInput source="label" />
      </SimpleForm>
    </Edit>
  );
};

export default DistrictEdit;
